import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { gsap } from 'gsap';
import splashGif from '../asserts/splash.mp4';
import logoImg from '../asserts/logost.png';
import './Splash.css';

const Splash = () => {
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const gifRef = useRef(null);
  const logoRef = useRef(null);
  const lightRef = useRef(null);
  const tapRef = useRef(null);
  const [tapped, setTapped] = useState(false);
  const tappedRef = useRef(false);

  useEffect(() => {
    const tl = gsap.timeline();

    gsap.set([gifRef.current, logoRef.current], { opacity: 0 });
    gsap.set(lightRef.current, { scale: 0.6, opacity: 0 });
    gsap.set(tapRef.current, { opacity: 0 });

    tl
      .to(lightRef.current, {
        scale: 1,
        opacity: 1,
        duration: 1.2,
        ease: 'power2.out',
      })
      .to(gifRef.current, {
        opacity: 1,
        duration: 0.5,
        ease: 'power1.in',
      }, '-=0.6')
      .to(gifRef.current, {
        opacity: 0,
        duration: 0.6,
        ease: 'power1.inOut',
        delay: 1.1,
      })
      .to(logoRef.current, {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out',
      }, '-=0.1')
      .to(tapRef.current, {
        opacity: 1,
        duration: 0.8,
        ease: 'power2.out',
        delay: 0.4,
      });
  }, []);

  const handleTap = () => {
    if (tappedRef.current) return;
    tappedRef.current = true;
    setTapped(true);

    gsap.to(tapRef.current, { opacity: 0, duration: 0.3 });
    gsap.to(logoRef.current, {
      opacity: 0,
      duration: 0.6,
      ease: 'power1.inOut',
      delay: 0.1,
    });
    gsap.to(containerRef.current, {
      opacity: 0,
      duration: 0.7,
      ease: 'power2.inOut',
      delay: 0.4,
      onComplete: () => navigate('/home'),
    });
  };

  return (
    <div
      className="splash-container"
      ref={containerRef}
      onClick={handleTap}
      onTouchStart={handleTap}
    >
      <div className="splash-light" ref={lightRef} />
      <video
        className="splash-gif"
        ref={gifRef}
        src={splashGif}
        autoPlay
        muted
        playsInline
      />
      <img className="splash-logo" ref={logoRef} src={logoImg} alt="GEM Studio logo" />
      <p className="splash-tap" ref={tapRef}>Tap to Start</p>
    </div>
  );
};

export default Splash;